/**
 * XLSX Icon SVG Component
 * A green Excel spreadsheet icon with a white XLSX text label.
 */
export function XlsxIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="12" y="8" width="40" height="48" rx="2" fill="#217346" />
      <path
        d="M12 10C12 8.89543 12.8954 8 14 8H38L52 22V54C52 55.1046 51.1046 56 50 56H14C12.8954 56 12 55.1046 12 54V10Z"
        fill="#1A5C38"
      />
      <path d="M38 8L52 22H40C38.8954 22 38 21.1046 38 20V8Z" fill="#217346" />
      <text
        x="32"
        y="40"
        fontSize="12"
        fontWeight="bold"
        fill="white"
        textAnchor="middle"
        fontFamily="system-ui"
      >
        XLSX
      </text>
    </svg>
  )
}
